import React, { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsalAuthentication } from '@azure/msal-react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import {
  InteractionType,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
import useAuthExternalUser from '../../hooks/useAuthExternalUser';
export const Login = () => {
  const { userType } = useAuthExternalUser();
   const isAuthenticated = useIsAuthenticated();
   const loginRequest = {
      scopes: ['User.Read'],
      loginHint: '',
    };
  const { login, error } = useMsalAuthentication('silent', loginRequest);
  useEffect(() => {
      if (!isAuthenticated && error instanceof InteractionRequiredAuthError) {
        if (userType === 'Internal' || userType !== 'External') {
          loginRedirect();
        }
      }
  }, [isAuthenticated, error]);

  const loginRedirect = () => {
    setTimeout(() => {
      login(InteractionType.Redirect);
    }, 300);
  };

  return (
    <Box className="acmLoader">
      <div className="auth-loader-container">
        <CircularProgress className="auth-loader" />
      </div>
    </Box>
  );
};

export default Login;
